import React from 'react';
import Router from './Routes';

function App() {
  return (
    <div>
    <Router />
    </div>
  );
}

export default App;
